
import { AbstractKappas } from './abstract-kappas.model';
import { User } from '../../models/user.model';

export class AbstractSearchResult {

  constructor(
    public abstractCount?: number,
    public reconEligibleCount?: number,
    public inQCListCount?: number,
    public inCoderQListCount?: number,
    public inCoderQAndReconListCount?: number,
    public inODPAdjudicationCount?: number,
    public highPriDisagreementCount?: number,
    public lowPriDisagreementCount?: number,
    public fullAgreementCount?: number,
    public highPriDisagreementReconCount?: number,
    public lowPriDisagreementReconCount?: number,
    public fullAgreementReconCount?: number,
    public abstractResult?: AbstractKappas[],
    public coderResult?: User[]
  ) {}
}
